import React, { useState, useEffect} from 'react';
import onClickUrl from "../OnClickUrl";

const projectsData = [
    {
          title: "Pedestrian Action Prediction",
          subtitle: "",
          date: "Feb 2026",
          url: "https://github.com/adityapatel149/pedestrian-action-anticipation-vjepa",
          image: "/images/pedestrian.png",
          points: [
              "Fine-tuned a probe on a foundation world model to predict pedestrian actions up to 3 seconds ahead from partial video observations without additional sensor modalities.",
              "Real-time inference pipeline for low-latency prediction on streaming video with multi-object tracking.",
              "Achieved 86% accuracy, competitive with multimodal SOTA methods.",
          ]
    },
    {
      title: "RGB-LiDAR-IMU Sensor Fusion",
      subtitle: "3D Reconstruction, Pose Estimation & Dynamic Object Removal",
      date: "May 2026",
      url: "https://github.com/adityapatel149/rgb-lidar-imu-3d-reconstruction",
      image: "/images/sensorfusion.png",
      points: [
        "Multimodal perception pipeline using CARLA simulation data for synchronized multicamera RGB, LiDAR, and IMU sensor fusion.",
        "Implemented LiDAR-Inertial Odometry and a 15-state ESKF.",
        "Generated RGB-colored static-world 3D reconstructions with dynamic object removal, reducing ghost trails.",
      ]
    },
    {
        title: "Theia Sense",
        subtitle: "Personalized Image Curation Based on Aesthetics",
        date: "July 2025",
        url: "https://theia-sense.wonderfulbush-e3ed6434.westus3.azurecontainerapps.io/",
        image: "/images/theia-sense.png",
        points: [
            "Architected a full-stack, cloud microservice application with a decoupled FastAPI backend and dedicated ML inference service. ",
            "Optimized model for production by converting to ONNX Runtime, reducing final container image size by 75%. ",
            "Deployed using Docker on Azure Container Apps and Huggingface Spaces for independent service scaling. "
        ]
    },
    {
        title: "YOLO11 Real-Time CV App",
        subtitle: "Object Detection, Segmentation & Pose Estimation",
        date: "Feb 2025",
        url: "https://github.com/adityapatel149/yolo-streamlit",
        image: "/images/cv-app.png",
        points: [
            "Deployed a YOLO11-powered application for real-time detection and pose estimation for images/videos. ",
            "Reduced latency by 30% through inference optimization and video processing pipeline enhancements. ",
            "Built interactive web app on Streamlit Cloud for real-time user engagement. "
        ]
    },
    {
        title: "Image2PointCloud",
        subtitle: "3D Reconstruction from 2D Images",
        date: "Feb 2025",
        url: "https://github.com/adityapatel149/Image2PointCloud",
        image: "/images/reconstruction.png",
        points: [
            "Developed a 3D CV pipeline to generate point clouds and meshes without depth data using monocular depth estimation. ",
            "Implemented multi-view registration using Fast Global Registration, Point-to-Plane ICP, and BCPD. ",
            "Automated 3D mesh generation using Poisson surface reconstruction. "
        ]
    },
    {
        title: "VLM-Enhanced Multimodal RAG",
        subtitle: "Chat with PDF (Text, Images, Graphs)",
        date: "Jan 2025",
        url: "https://github.com/adityapatel149/chat-with-pdf",
        image: "/images/rag-chat.png",
        points: [
            "Designed a multimodal RAG pipeline using LangChain, Chromadb, and Unstructured. ",
            "Integrated GPT-4 with vision and GROQ to perform deep document understanding of complex PDF elements. "
        ]
    },

    {
        title: "RL agents for Highway-env",
        subtitle: "Multi-Agent RL Project",
        date: "2025",
        url: "https://github.com/adityapatel149/team7-agents",
        image: "/images/agents.png",
        points: [
            "Implemented multi-agent reinforcement learning algorithms for autonomous agents in simulated environments. "
        ]
    },
    {
        title: "Custom RL Environment",
        subtitle: "Custom RL Environment",
        date: "2025",
        url: "https://github.com/adityapatel149/team7-custom-env",
        image: "/images/custom-env.png",
        points: [
            "Designed and developed custom RL environments for testing multi-agent strategies. "
        ]
    },
    {
        title: "Simulating SLAM from scratch",
        subtitle: "Python-based Robotics Simulation",
        date: "Mar 2025",
        url: "https://github.com/adityapatel149/Simulating-LIDAR-from-floor-map",
        image: "/images/slam-sim.png",
        points: [
            "Designed and developed a simple 2D SLAM by simulating and generating 2D LiDAR data from floor maps. ",
            "Implemented point cloud feature extraction and data association from scratch for SLAM. "
        ]
    },
    {
        title: "Crowd and Flock Simulation",
        subtitle: "C++ & OpenFrameworks Graphics",
        date: "Feb 2025",
        url: "https://github.com/adityapatel149/flocking",
        image: "/images/flock-sim.png",
        points: [
            "Developed a 3D flock simulation utilizing physically based particle simulations in C++. ",
            "Utilized OpenFrameworks for creating graphics and programming simulations with varying parameter controls. "
        ]
    },
    {
        title: "GAN-Driven Weight Initialization",
        subtitle: "Synthetic Model Generation for Image Classification",
        date: "Nov 2024",
        url: "https://github.com/adityapatel149/synthetic-model-generation",
        image: "/images/gan-weights.png",
        points: [
            "Created a novel pipeline for synthetic model weight generation without pre-existing training data (88% accuracy). ",
            "Adapted CycleGAN architecture to generate custom CNN weights using pretrained filters as input. "
        ]
    },
    {
        title: "Wordle Clone",
        subtitle: "React.js & Redux Hooks",
        date: "Oct 2023",
        url: "https://wordle-adityapatel149.vercel.app",
        image: "/images/wordle.jpg",
        points: [
            "Deployed fully functional clone with over 300 active users.",
            "Optimized algorithms to decrease memory consumption by 30% and computation time by 65%. "
        ]
    },
    {
        title: "UI Design Collection",
        subtitle: "Fitness & Coffee Shop Apps",
        date: "Oct 2023",
        url: "https://dribbble.com/AdityaPatel149",
        image: "/images/ui-collection.png",
        points: [
            "Designed intuitive UIs focusing on user-friendly navigation, engaging visuals, and seamless functionality. "
        ]
    },
    {
        title: "Mood Snack Brand",
        subtitle: "Brand Design & Landing Page",
        date: "Oct 2023",
        url: "https://dribbble.com/shots/22873068-Brand-Design-and-Landing-Page-for-Snacks-brand-MOOD",
        image: "/images/mood-thumbnail.png",
        points: [
            "Developed unique brand identity including logo, packaging, and visual design. ",
            "Created a high-converting landing page to showcase products and drive engagement. "
        ]
    },
    {
        title: "3d-ball-bouncing-simulation",
        subtitle: "Physics Simulation in 3D",
        date: "2025",
        url: "https://github.com/adityapatel149/3d-ball-bouncing-simulation",
        image: "/images/meta.png",
        points: [
            "Simulated 3D physics of bouncing balls with collision detection and response. "
        ]
    },
    {
        title: "blogs-redux",
        subtitle: "React Blog App with Redux",
        date: "2024",
        url: "https://github.com/adityapatel149/blogs-redux",
        image: "/images/meta.png",
        points: [
            "Developed a scalable React blog app with Redux for state management. "
        ]
    },
    {
        title: "Gradient-based-HMM",
        subtitle: "Hidden Markov Model Implementation",
        date: "2024",
        url: "https://github.com/adityapatel149/Gradient-based-HMM",
        image: "/images/meta.png",
        points: [
            "Implemented gradient-based Hidden Markov Models for sequence prediction tasks. "
        ]
    },
    {
        title: "binary-classifier-CNN",
        subtitle: "CNN-based Binary Classification",
        date: "2024",
        url: "https://github.com/adityapatel149/binary-classifier-CNN",
        image: "/images/meta.png",
        points: [
            "Trained CNNs for binary image classification with data augmentation and optimization. "
        ]
    },
    {
        title: "caesar-cipher-HMM",
        subtitle: "Cipher Decryption with HMM",
        date: "2024",
        url: "https://github.com/adityapatel149/caesar-cipher-HMM",
        image: "/images/meta.png",
        points: [
            "Decrypted Caesar ciphered text using Hidden Markov Model approaches. "
        ]
    },
    {
        title: "AstroSling",
        subtitle: "Physics-based Game",
        date: "2023",
        url: "https://github.com/adityapatel149/AstroSling",
        image: "/images/meta.png",
        points: [
            "Created a physics-based game using 2D projectile mechanics and interactive graphics. "
        ]
    },
    {
        title: "Enhanced-Product-Sales-Manager",
        subtitle: "Inventory & Sales Management App",
        date: "2023",
        url: "https://github.com/adityapatel149/Enhanced-Product-Sales-Manager",
        image: "/images/meta.png",
        points: [
            "Developed a full-stack sales and inventory management app with analytics dashboard. "
        ]
    },
    {
        title: "imagesearcher",
        subtitle: "Image Search Engine",
        date: "2023",
        url: "https://github.com/adityapatel149/imagesearcher",
        image: "/images/meta.png",
        points: [
            "Implemented a search engine for images with filtering and ranking functionalities. "
        ]
    },
    {
        title: "youtube-app",
        subtitle: "React YouTube Clone",
        date: "2023",
        url: "https://github.com/adityapatel149/youtube-app",
        image: "/images/meta.png",
        points: [
            "Built a React-based YouTube clone with video playback and subscription features. "
        ]
    },
    {
        title: "connect4",
        subtitle: "Classic Connect 4 Game",
        date: "2023",
        url: "https://github.com/adityapatel149/connect4",
        image: "/images/meta.png",
        points: [
            "Developed a fully playable Connect 4 game with AI opponent. "
        ]
    }
];

export default function LatestProjects() {
    
    const getMaxProjects = () => {
        const width = window.innerWidth;

        if (width >= 1400) return 12; // large desktop
        if (width >= 800) return 8;   // tablet
        return 6;                     // mobile
    };

    const [showAll, setShowAll] = useState(false);
    const [maxProjects, setMaxProjects] = useState(getMaxProjects());


    useEffect(() => {
        const handleResize = () => {
            setMaxProjects(getMaxProjects());
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const displayedProjects = showAll
        ? projectsData
        : projectsData.slice(0, maxProjects);

    return (
        <section className="latest-projects section-container">
            <div className="title-and-icon">
                <h2>Latest Projects</h2>
                <div className="social">
                    <i
                        className="fa-brands fa-github fa-3x"
                        onClick={onClickUrl("https://github.com/adityapatel149")}
                    >
                        ↗
                    </i>
                </div>
            </div>

            <div className="content-container-horizontal">
                {displayedProjects.map((project, index) => (
                    <div
                        key={index}
                        className="project"
                        onClick={onClickUrl(project.url)}
                        role="button"
                        tabIndex={0}
                    >
                        <img src={project.image} alt={`${project.title} thumbnail`} />
                        <div className="project-content">
                            <h4>{project.title}</h4>
                            <ul>
                                {project.points.map((point, idx) => (
                                    <p key={idx}>{point}</p>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>

            {!showAll && projectsData.length > maxProjects && (
                <div className="see-all-container">
                    <button className="primary-button" onClick={() => setShowAll(true)}>
                        <div className="btn-inside">
                            <div className="btn-inside2">See All</div>
                        </div>
                    </button>
                </div>
            )}

            {showAll && (
                <div className="see-all-container">
                    <button className="primary-button" onClick={() => setShowAll(false)}>
                        <div className="btn-inside">
                            <div className="btn-inside2">Show Less</div>
                        </div>
                    </button>
                </div>
            )}
        </section>
    );
}
